module.exports = __webpack_public_path__ + "media/dorobek/assets/images/article-495b0fefcdd18cf317153f5fbda0864b.svg";